/**
 * Plain div newsletter drawer (replaces x-drawer for full width control).
 */
(function () {
  if (window.__newsletterDrawerBound) return;
  window.__newsletterDrawerBound = true;

  function getDrawer(trigger) {
    var id = trigger.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function resetNewsletterState(drawer) {
    var newsletter = drawer.querySelector('[data-klaviyo-newsletter]');
    if (!newsletter) return;
    newsletter.classList.remove('is-success');
    var confirmation = newsletter.querySelector('[data-klaviyo-confirmation]');
    if (confirmation) confirmation.hidden = true;
    var form = drawer.querySelector('[data-klaviyo-form]');
    if (form) {
      form.reset();
      form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function openDrawer(drawer, trigger) {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('newsletter-drawer-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    var closeBtn = drawer.querySelector('.newsletter-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('newsletter-drawer-open');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
        resetNewsletterState(drawer);
      }
    }, 320);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.footer__newsletter-trigger[aria-controls]');
    if (trigger) {
      var drawer = getDrawer(trigger);
      if (!drawer || !drawer.classList.contains('newsletter-drawer')) return;
      event.preventDefault();
      if (drawer.classList.contains('is-open')) {
        closeDrawer(drawer);
      } else {
        openDrawer(drawer, trigger);
      }
      return;
    }

    var closeEl = event.target.closest('[data-newsletter-drawer-close]');
    if (closeEl) {
      var drawerToClose = closeEl.closest('.newsletter-drawer');
      if (drawerToClose) closeDrawer(drawerToClose);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openDrawerEl = document.querySelector('.newsletter-drawer.is-open');
    if (openDrawerEl) closeDrawer(openDrawerEl);
  });
})();
